import { makeAutoObservable } from 'mobx';
import {types, endpoints} from 'main/tools';
import {DomainStore} from 'shared/store';

class EmployeeDirectoryPageState {
  store = new DomainStore();
  scope;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([
      endpoints.EMPLOYEE_DIRECTORY.NAVIGATION
    ]);

    this.scope = this.store._getSingle(types.NAVIGATION_SCOPE).tabs;
  }
}

export default EmployeeDirectoryPageState;
